export default __webpack_public_path__ + "static/media/profileIcon.svg.631518a9.svg";